import { Card, CardContent, Chip, Stack, Typography } from '@mui/material';

const styles = {
  icon: {
    margin: '2px',
    color: '#777',
    fontSize: '11px',
  },
};

const Back = props => {
  const {
    data = {},
    desc: descKey = "description",
    icons: iconsKey = "tech",
  } = props;

  const description = data[descKey];
  const icons = data[iconsKey] || [];

  return (
    <Card className="card back">
      <CardContent>
        <Typography dangerouslySetInnerHTML={{ __html: description }} />
        <Stack direction="row" sx={{ flexWrap: 'wrap' }}>
          {icons.map(icon => (
            <Chip key={icon} label={icon} size="small" sx={styles.icon} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default Back;
